/*
 * Purpose: Public system status page — live /health polling (no auth)
 * Last modified: 2026-06-28 | Agent
 * Completeness: 96
 */
import { Link } from 'react-router-dom';
import { BrandMark } from '@/components/brand/BrandMark';
import { SystemHealthDashboard } from '@/components/health/SystemHealthDashboard';
import { PageMotion } from '@/components/motion/PageMotion';
import { APP_ROUTES } from '@/lib/appRoutes';
import { PRODUCT_NAME } from '@/lib/productTerms';
import { Button } from '@/components/ui/button';

export default function SystemHealthPage() {
  return (
    <PageMotion variant="body">
      <div className="min-h-screen flex flex-col bg-background">
        <header className="shrink-0 border-b border-border/40 px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
          <Link to={APP_ROUTES.home} className="flex items-center gap-2 min-w-0">
            <BrandMark size={24} ghostAccent="darker" />
            <span className="ab-brand-wordmark text-sm truncate">{PRODUCT_NAME}</span>
          </Link>
          <div className="flex gap-2 shrink-0">
            <Button size="sm" variant="ghost" asChild>
              <Link to={APP_ROUTES.help}>Support</Link>
            </Button>
            <Button size="sm" variant="outline" asChild>
              <Link to={APP_ROUTES.home}>Home</Link>
            </Button>
          </div>
        </header>

        <main className="flex-1 max-w-3xl mx-auto w-full px-4 sm:px-6 py-6 sm:py-10 space-y-4">
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-foreground">System status</h1>
            <p className="text-sm text-muted-foreground mt-1">
              Public, real-time health and security audit — updates every 5 seconds from{' '}
              <code className="text-xs bg-muted px-1 rounded">/health</code>.
            </p>
          </div>
          <SystemHealthDashboard />
        </main>
      </div>
    </PageMotion>
  );
}
